import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'templateString',
  standalone: true,
})
export class TemplateStringPipe implements PipeTransform {
  transform(template: string, values: Record<string, string>): string {
    let result: string = template;
    const doubleBrackets = /{{[^{](.*?)[^}]}}/g;
    const termsInDoubleBrackets: string[] =
      template.match(doubleBrackets) ?? [];
    //replace matching terms
    Object.keys(values).forEach((key: string) => {
      if (termsInDoubleBrackets.includes(`{{${key}}}`)) {
        while (result.includes(`{{${key}}}`)) {
          result = result.replace(`{{${key}}}`, values[key] ?? '');
        }
      }
    });

    return result;
  }
}
